import type { AphroditeCSSProperties } from '../utils/aphrodite';

/* eslint no-multi-spaces:0 */
/* eslint key-spacing:0 */

export const icons = {
  add: '"\\e902"',
  addCircle16: '"\\e903"',
  balance16: '"\\e909"',
  balanceEuro16: '"\\e9ac"',
  balanceGBP16: '"\\e908"',
  bankAccount32: '"\\e90a"',
  check16: '"\\e911"',
  clock: '"\\f017"',
  close16: '"\\e913"',
  close24: '"\\e914"',
  connectPoints: '"\\e9cc"',
  deleteCircle16: '"\\e918"',
  dropdownArrow16: '"\\e91f"',
  duration16: '"\\e921"',
  email32: '"\\e924"',
  error16: '"\\e926"',
  errorCircle16: '"\\e928"',
  externalLink16: '"\\e92a"',
  faceBook: '"\\e9c8"',
  faceBook32: '"\\e9a2"',
  google: '"\\e9c9"',
  google2: '"\\e9ca"',
  help16: '"\\e97a"',
  home32: '"\\e938"',
  least: '"\\e9c2"',
  like: '"\\e9c1"',
  linkedin: '"\\e99e"',
  linkedin32: '"\\e9a5"',
  logout16: '"\\e941"',
  logout32: '"\\e942"',
  menu24: '"\\e988"',
  mobile32: '"\\e948"',
  most: '"\\e9c6"',
  next16: '"\\e94a"',
  notification16: '"\\e94b"',
  offers32: '"\\e94c"',
  password32: '"\\e951"',
  paypal32: '"\\e953"',
  photoCard32: '"\\e954"',
  previous16: '"\\e956"',
  pureprofile: '"\\e999"',
  referrals32: '"\\e9a8"',
  reorder16: '"\\e960"',
  rewards32: '"\\e962"',
  satisfaction: '"\\e9c2"',
  satisfaction2: '"\\e9c4"',
  satisfaction3: '"\\e9c6"',
  settings16: '"\\e969"',
  settings32: '"\\e96a"',
  smartfuel16: '"\\e9c7"',
  star16: '"\\e98a"',
  transactionGBP32: '"\\e907"',
  transactions32: '"\\e971"',
  transactionsNcaNormal: '"\\e9cb"',
  twitter: '"\\e99f"',
  twitter32: '"\\e9a7"',
  uploadPhoto32: '"\\e976"',
  user32: '"\\e978"',
};

export const getIcon = (icon: any): AphroditeCSSProperties => ({
  '-webkit-font-smoothing': 'antialiased',
  ':before': {
    content: icon,
  },
  fontFamily: 'Pureprofile',
  fontStyle: 'normal',
  'vertical-align': 'middle',
});

export const getIconStyles = (icon: any) =>
  ({
    '&::before': {
      content: icon,
    },
    fontFamily: 'Pureprofile',
    fontSmooth: 'antialiased',
    fontStyle: 'normal',
    verticalAlign: 'middle',
  }) as const;
